<template>
  <div :class="'custom_input '+width">
    <div class="label">
      {{ capitalisedLabel }}
    </div>
    <div class="input_group">
      <input
        v-model="
          // TODO: fix no mutating prop linter errors
          // eslint-disable-next-line vue/no-mutating-props
          modelValue
        "
        :placeholder="placeholder"
        :type="type"
        autocomplete="off"
        class="input input_field"
        @change="updateValue()"
      >
      <div
        class="color_picker"
        @click="openColorPicker = true"
      >
        <div
          :style="'background-color:'+modelValue+';'"
          class="selected_color"
        />
        <color-picker
          v-if="openColorPicker"
          v-model="
            // eslint-disable-next-line vue/no-mutating-props
            modelValue
          "
          @close="openColorPicker = false"
        />
      </div>
    </div>
    <small
      v-for="(error, index) in validationErrors"
      :key="index"
      class="validation"
    >{{ error }}</small>
  </div>
</template>
<script>
import _ from 'lodash';
import ColorPicker from './ColorPicker.vue';

export default {
  components: {ColorPicker},
  props: {
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    modelValue: {
      type: [String, Number],
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    width: {
      type: String,
      required: false,
      default: 'full'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    validationErrors: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      openColorPicker: false
    }
  },
  computed: {
    capitalisedLabel() {
      let words = this.label.split(' ');
      _.each(words, (word, index) => {
        words[index] = _.capitalize(word);
      });
      return words.join(' ');
    }
  },
  watch: {
    modelValue: {
      handler() {
        this.$emit('update:modelValue', this.modelValue);
      }
    }
  },
  methods: {
    updateValue() {
      this.$emit('update:modelValue', this.modelValue);
    },
  }
};
</script>
<style scoped>
.input_group {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.input_field {
  width: 75%;
}

.color_picker {
  width: 15%;
  height: 3rem;
  border: solid 1px #E8E5E2;
  border-radius: 12px;
  margin-left: 10px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selected_color {
  width: 90%;
  height: 90%;
  border: solid 1px lightgray;
}

.custom_input {
  margin-bottom: 1.5rem;
}

.full {
  width: 100%;
}

.two-thirds {
  width: calc(66.66% - .5rem);
}

.half {
  width: calc(50% - .5rem);
}

.third {
  width: calc(33.33% - .5rem);
}

.quarter {
  width: calc(25% - .5rem);
}

.input {
  width: 100%;
  color: #4E4E54;
  background-color: #fff;
  border: 1px solid #E8E5E2;
  padding: 14.5px 24.5px 15.5px;
  border-radius: 12px;
  height: 3rem;
  font-size: 14px;
  letter-spacing: -0.5px;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.label {
  margin-bottom: .25rem;
  font-size: 0.75rem;
  line-height: 1.3;
  letter-spacing: -0.1px;
  color: #909096;
}

.input::-webkit-input-placeholder {
  color: #9999a3;
  -webkit-transition: .3s;
  transition: .3s;
}

.input::-moz-placeholder {
  color: #9999a3;
  -moz-transition: .3s;
  transition: .3s;
}

.input:-ms-input-placeholder {
  color: #9999a3;
  -ms-transition: .3s;
  transition: .3s;
}

.input::-ms-input-placeholder {
  color: #9999a3;
  -ms-transition: .3s;
  transition: .3s;
}

.input::placeholder {
  color: #9999a3;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
}

.input:focus::-webkit-input-placeholder {
  color: transparent;
}

.input:focus::-moz-placeholder {
  color: transparent;
}

.input:focus:-ms-input-placeholder {
  color: transparent;
}

.input:focus::-ms-input-placeholder {
  color: transparent;
}

.input:focus::placeholder {
  color: transparent;
}

.validation {
  text-align: center;
  color: red;
  margin-left: 10px;
}
</style>
